module.exports = __webpack_public_path__ + "static/media/Bakery-01.da85fc45.svg";